/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */
import { createReducer } from 'reduxsauce';
import { ProdSheetIndexTypes } from './Actions';
import INITIAL_STATE from './InitialState';

export const prodSheetIndexResetTimestamp = (state, { currentPage, sorts, filters, pageSize }) => ({
  ...state,
  currentPage: currentPage || state.currentPage,
  sorts: sorts || state.sorts,
  filters: filters || state.filters,
  pageSize: pageSize || state.pageSize,
  timestamp: Date.now()
});

export const prodSheetIndexFetchProdSheetIndexLoading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const prodSheetIndexFetchProdSheetIndexSuccess = (
  state,
  { documents, currentPage, lastPage, total, pageSize }
) => ({
  ...state,
  documents,
  currentPage,
  lastPage,
  total,
  pageSize
});

export const prodSheetIndexSetExpandedRows = (state, { expandedRows }) => ({
  ...state,
  expandedRows
});

export const prodSheetIndexAddSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = state.selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: [
      ...state.selectedDocuments,
      ...selectedDocuments.filter(data => {
        return !selectIds.includes(data.id);
      })
    ]
  };
};

export const prodSheetIndexRemoveSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: state.selectedDocuments.filter(data => {
      return !selectIds.includes(data.id);
    })
  };
};

export const prodSheetIndexSetWorkspaceVisible = (state, { boolean }) => ({
  ...state,
  workspaceIsVisible: boolean
});

export const prodSheetIndexWorkspaceLoading = (state, { boolean }) => ({
  ...state,
  workspaceIsLoading: boolean
});

export const prodSheetIndexResetProdSheetFServ01Success = state => ({
  ...state,
  timestamp: Date.now(),
  selectedDocuments: []
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [ProdSheetIndexTypes.PROD_SHEET_INDEX_RESET_TIMESTAMP]: prodSheetIndexResetTimestamp,
  [ProdSheetIndexTypes.PROD_SHEET_INDEX_FETCH_PROD_SHEET_INDEX_LOADING]: prodSheetIndexFetchProdSheetIndexLoading,
  [ProdSheetIndexTypes.PROD_SHEET_INDEX_FETCH_PROD_SHEET_INDEX_SUCCESS]: prodSheetIndexFetchProdSheetIndexSuccess,
  [ProdSheetIndexTypes.PROD_SHEET_INDEX_ADD_SELECTED_DOCUMENTS]: prodSheetIndexAddSelectedDocuments,
  [ProdSheetIndexTypes.PROD_SHEET_INDEX_REMOVE_SELECTED_DOCUMENTS]: prodSheetIndexRemoveSelectedDocuments,
  [ProdSheetIndexTypes.PROD_SHEET_INDEX_SET_WORKSPACE_VISIBLE]: prodSheetIndexSetWorkspaceVisible,
  [ProdSheetIndexTypes.PROD_SHEET_INDEX_WORKSPACE_LOADING]: prodSheetIndexWorkspaceLoading,
  [ProdSheetIndexTypes.PROD_SHEET_INDEX_RESET_PROD_SHEET_F_SERV01_SUCCESS]: prodSheetIndexResetProdSheetFServ01Success
});
